export const visitDateEvent = (isDayTicket = false, maybeCallback = undefined, buttonText) => {
    // Booking widget lives in a modal — keep Book Now opening the modal.
    if (document.getElementById('modal-booking-form')) {
        return;
    }
    window.dispatchEvent(new CustomEvent('primary.action.override', {
        detail: {
            buttonText: buttonText ?? 'Book Now',
            buttonAction: () => {
                const element = isDayTicket
                    ? document.querySelector('.section.section--day-tickets .react-datepicker')
                    : document.querySelector('.section.section--booking-form .react-datepicker');
                if (!element) {
                    return;
                }
                // get the element of the block on the page.
                const location = element?.getBoundingClientRect().top + window.scrollY;
                const offset = 200;
                window.scrollTo(0, location - offset);
                if (maybeCallback) {
                    maybeCallback();
                }
            },
            buttonEnabled: true,
        },
    }));
};
export const visitDateSelectedEvent = () => {
    window.dispatchEvent(new CustomEvent('primary.action.override', {
        detail: {
            buttonText: 'Book Now!',
            buttonAction: () => { },
            buttonEnabled: false,
        },
    }));
};
export const formCompleteEvent = (isSubmitting, submitEvent) => {
    window.dispatchEvent(new CustomEvent('primary.action.override', {
        detail: {
            buttonText: 'Book Now!',
            buttonAction: () => {
                if (!isSubmitting) {
                    submitEvent();
                }
            },
            buttonEnabled: !isSubmitting,
        },
    }));
};
export default visitDateEvent;
